var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0662B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,19.5H3.4c-1.6,0-2.8-1.3-2.8-2.8v-3.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v3.8 c0,0.5,0.4,0.9,0.9,0.9h13.3c0.5,0,0.9-0.4,0.9-0.9v-3.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v3.8 C19.5,18.2,18.2,19.5,16.6,19.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,13.8c-0.2,0-0.5-0.1-0.7-0.3L4.6,8.8c-0.4-0.4-0.4-1,0-1.3c0.4-0.4,1-0.4,1.3,0l4.1,4.1l4.1-4.1 c0.4-0.4,1-0.4,1.3,0c0.4,0.4,0.4,1,0,1.3l-4.7,4.7C10.5,13.7,10.2,13.8,10,13.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,13.8c-0.5,0-0.9-0.4-0.9-0.9V1.5C9.1,1,9.5,0.5,10,0.5s0.9,0.4,0.9,0.9v11.4C10.9,13.4,10.5,13.8,10,13.8 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.a4e93b682a3e9a0075be2d86bd806d99.svg";
export { ForwardRef as ReactComponent };